<template>
	<div class="row animate fadeIn col-12 py-4 px-0 mx-0">
        <div class="col-md-6 row col-sm-12 text-center px-5 d-flex flex-wrap align-items-center mx-0">
			<div class="col-12"> 
				  <i class="fas fa-check-circle fa-5x text-blue"></i>
					<h2 class="text-blue mt-0">Awesome!</h2>
					<div class="d-flex">
						<h3 class="text-blue mr-4 mt-1">100%</h3>
						<div class="flex-grow-1 pt-3">
							<div class="blue-line">&nbsp;</div>
						</div>
					</div>
					<p>Just a final check that all your details are correct.</p>
			</div>
        </div>

        <div class="col-md-6 col-sm-12 "> 
			<h3>Your Summary</h3>
			<div class="custom-scroll" :style="windowWidth >= 700 ? {'height':windowHeight - 420+'px !important'} : ''">
				<div v-for="(message, index) in getFormFields" :key="index">
					<div class="row mx-0 px-0" v-if="message.question !== undefined && message.question.answer_type =='text'">
						<div class="d-flex justify-content-between bg-white p-2 col-12"> 
							<div class="mr-2 align-items-center d-flex col-3 px-0">
								{{ message.question.data.label }}
							</div>
							<input
								type="text"
								:placeholder="message.question.data.help"
								class="form-control col d-flex "
								v-model="message.content.data"
								required
							/>
						</div>
						<!-- <div class="choice_box animate zoomIn delay-5s">
						<input
							:type="data.field.type"
							:placeholder="res.field.help"
							class="form-control"
							:data-elementKey="index"
							:id="res.field.label"
							v-if="res.field.type != 'number'"
						/>
						<input
							:type="res.field.type"
							:placeholder="res.field.help"
							class="form-control"
							:id="res.field.label"
							:data-elementKey="index"
							v-if="res.field.type == 'number'"
							min="0"
							step="0.01"
						/>
						<br />
						<div v-show="showErrorMessage">
							<span class="error_message">{{ error }}</span>
							<br />
						</div>
						<div class="btn btn-default" v-on:click="typeResponse(res.field.label)">Submit</div>
						</div> -->
					</div>

					<div class="row mx-0 px-0" v-else-if="message.question !== undefined && message.question.answer_type =='email'">
						<div class="d-flex justify-content-between bg-white p-2 col-12"> 
							<div class="mr-2 align-items-center d-flex col-3 px-0">
								{{ message.question.data.label }}
							</div>
							<input
								type="email"
								:placeholder="message.question.data.help"
								class="form-control col d-flex "
								v-model="message.content.data"
								required
							/>
						</div>
					</div>

					<div class="row mx-0 px-0" v-else-if="message.question !== undefined && message.question.answer_type =='currency'">
						<div class="d-flex justify-content-between bg-white p-2 input-group col-12"> 
							<div class="mr-2 align-items-center d-flex col-3 px-0">
								{{ message.question.data.label }}
							</div>
							<div class="input-group-prepend">
								<span class="input-group-text">$</span>
								</div>
								<input
								type="number"
								step=1
								min=0
								:placeholder="message.question.data.help"
								class="form-control col d-flex "
								v-model="message.content.data"
								required
								/>
								<div class="input-group-append">
								<span class="input-group-text">.00</span>
							</div>
						</div>
					</div>

					<div class="row mx-0 px-0" v-else-if="message.question !== undefined && message.question.answer_type =='number'">
						<div class="d-flex justify-content-between bg-white p-2 col-12"> 
							<div class="mr-2 align-items-center d-flex col-3 px-0">
								{{ message.question.data.label }}
							</div>
							<input
								type="number"
								step=1
								min=0
								:placeholder="message.question.data.help"
								class="form-control col d-flex "
								v-model="message.content.data"
								required
							/>
						</div>
					</div>
				</div>
				<div class="row mx-0 px-0">
					<div class="d-flex justify-content-between bg-white p-2 col-12"> 
						<div class="mr-2 align-items-center d-flex col-3 px-0">
							
						</div>
						<div
							class="form-control col d-flex btn-blue align-items-center justify-content-center"
							@click="chatQueryCompleted"
						>
				            <i class="fas fa-check-circle mr-4"></i>
							Yes, The Details are correct
						</div>
					</div>
				</div>
			</div>
        </div>
		 <!-- <p>Thanks for your responses,We will be in touch shortly.</p>
        <div class="btn btn-default" v-on:click="restartChat">
          <i class="fas fa-redo"></i> Restart
        </div> -->
	</div>
</template>

<script>
	/**
	 *  Import dependencies & event bus
	 */
	import store from '../../store'
	import { mapState, mapActions } from 'vuex'
	import { EventBus } from '../../event-bus'
	import Cookies from 'js-cookie'
	import * as appConfigs from '../../configs'
	import axios from 'axios'
    import queryString from 'query-string'
	import { includes } from 'lodash'

	/**
	 * Import local components
	 */

    
    export default {
        props: [
            'data', 'messages', 'windowHeight', 'windowWidth'
        ],
		store,
	    components: {},
		mounted() {
            this.initializeReminderToken();
		},

		computed: {
			...mapState({
				configs: state => state.configs,
				orderId: state => state.orderId, // 3026
				pendingOrder: state => state.pendingOrder,
				selectedOccupation: state => state.selectedOccupation,
				step: state => state.step,
				prevStep: state => state.prevStep,
				unavailableOccupations: state => state.unavailableOccupations,
			}),

			showSidebar () {
				return this.step >= 5
			},

			showInReferral () {
				return (
					Cookies.get('convertFromReferral') != this.pendingOrder.id &&
					this.pendingOrder.in_referral
				)
			},

			showUnavailableOccupation () {
				if (
					this.step >= 3 &&
					this.prevStep >= 2 &&
					(
						includes(this.unavailableOccupations, this.pendingOrder.occupation_id) ||
						this.pendingOrder.current_annual_revenue > 2500000 ||
						this.pendingOrder.status == 'HS'
					)
				) {

					// Cleaning the pendingOrderId because
					// after the thank you page, user should be able to fill out the form again
					Cookies.remove('pendingOrderId')
					return true;
				}

				return false;
			},

			getFormFields(){
				var messages = this.messages;
				messages.forEach( (item, index) =>{
					item.id = index;
					if(item.type === "user"){
						item.question = messages[index-1].questions ?? null
					};
				});

				messages = messages.filter(item=> {
					return item.question !== undefined && item.question !== null;
				})
				return messages;
			}
		
		},

        methods: {
            //check if reminder token exists, if it is then need to fire an ajax request to
            //check if the token is valid, then set the cookie, otherwise no further action
            //needed to be taken
            initializeReminderToken(){
                let vm = this
                let queryStringObj = queryString.parse(location.search)
                if('reminder_token' in queryStringObj)
                {
                    //if any error/exception occur, do not need to do anything, so axios do not need
                    //catch to handle error
                    axios.get(appConfigs.decryptReminderTokenUrl, {
                        params: queryStringObj
                    }).then((response) => {
                        if(response.data.status == 'error')
                        {
                            Cookies.remove('pendingOrderId')
                            vm.$store.commit('setError', { error: response.data.message })
                        }
                        else if(response.data.status == 'success')
                        {
					        Cookies.set('pendingOrderId', response.data.pending_order_id)
                        }

                    }).catch(error => {
						Cookies.remove('pendingOrderId')
                        vm.$store.commit('setError', { error: 'Invalid token error' })
                    })
                }
			},
			formatCurrency(value){
				var parts = value.toString().split(".");
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				value = "$" + parts.join(".");
				return value;
			},
			chatQueryCompleted() {
				this.$emit("chatQueryCompleted", this.messages);
			}
        }
	}
</script>

<style>
.relative{
  position: relative;
}
.absolute{
  position: absolute;
}
.message_user{
    padding: 10px;
}
.text-blue{
    color: #1e98e0;
}
.btn-blue{
    background-color: #1e98e0;
	color: #fff;
	text-transform: uppercase;
	text-align: center;
	cursor:pointer;
	border: 1px solid #1e98e0;
}
.btn-blue:hover{
	background-color: #009245 !important;
	border: 1px solid #009245 !important;
	
}
.blue-line{
    background-color: #1e98e0;
    border-radius: 10px;
    height:8px;
}
.message-box_user{
    border: 2px solid #bce4f9;
    background-color: #bce4f9;
    padding: 10px;
    color: #000;
    margin-top:3px;
	border-radius: 15px 0px 15px 15px;
	width: fit-content;
	max-width: 60%;
	text-align: right;
	font-size: 16px;
	line-height: 26px;
}
@media screen and (max-width: 768px) {
 	.message_user{
		padding: 5px !important;
		max-width: 100%;
	}
	.message-box_user{
		max-width: 100%;
	}
}
</style>
    